import BaseUrl from "./BaseUrl";

function BaseApi(){
   // "https://edotco.iotajra.com/api";
      return `${BaseUrl()}/api`;
}
export default BaseApi;